import React from 'react'

export default function Footer() {
    return (
        <footer>
            <p>Copyright by <a href={"https://github.com/Alisher-Usmonov"} target="_blank" rel="noreferrer">Alisher Usmonov</a>  &copy; | All Right reserved</p>            
        </footer>
    )
}
